var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-container',[_c('v-data-table',{attrs:{"headers":_vm.columns,"hide-default-footer":_vm.items.length < _vm.pagination.itemsPerPage,"items":_vm.items,"options":_vm.pagination},scopedSlots:_vm._u([{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.amount))+" ")]}},{key:"item.sale",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.sale))+" ")]}},{key:"item.purchase",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.purchase))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }